export enum PaymentMethodEnum {
  PAYU_INSTALLMENTS = 'PM_PAYU_M',
  BANK_TRANSFER = 'PM_BT',
  PAID_BY_CLIENT = 'PM_PBC',
}
